// removed by extract-text-webpack-plugin
module.exports = {"SearchResults":"genericSearchResults__SearchResults__1OdKc","SearchResItem":"genericSearchResults__SearchResItem__34qYu","FlexRow":"genericSearchResults__FlexRow__x26Fc"};


//////////////////
// WEBPACK FOOTER
// ./src/Components/Search/genericSearchResults.css
// module id = 1702
// module chunks = 2